import React, { useContext } from "react";
import ReactTooltip from "react-tooltip";
import BattleContext from "./BattleContext";
import stringifyBit from "./bitTextParser";
import "./Gambit.css";
import {
  GambitTooltipProp,
  IBitComponentProp,
  IGambitComponentProp
} from "./types";

function Bit({ bit, onClick, tooltipId }: IBitComponentProp) {
  const { isFirstTurn } = useContext(BattleContext);
  const disabled = !isFirstTurn;
  const className = `bit nes-btn ${disabled ? "is-disabled" : ""}`;
  return (
    <button
      type="button"
      disabled={disabled}
      className={className}
      onClick={onClick}
      data-tip=""
      data-for={tooltipId}
    >
      {stringifyBit(bit)}
    </button>
  );
}

export function GambitTooltip({ id, action }: GambitTooltipProp) {
  return (
    <ReactTooltip id={id}>
      <table className="nes-table is-centered is-dark">
        <tbody>
          <tr>
            <td>Cost</td>
            <td>{`${action.cost ?? 0} BP`}</td>
          </tr>
          <tr>
            <td>Intensity</td>
            <td>{`${action.intensity ?? 1}`}</td>
          </tr>
          {action.affinity && (
            <tr>
              <td>Affinity</td>
              <td>{`${action.affinity}`}</td>
            </tr>
          )}
        </tbody>
      </table>
    </ReactTooltip>
  );
}

export default function Gambit(props: IGambitComponentProp) {
  const { gambit, clickHandler = () => {} } = props;
  const onClickMaker = (label: string) => () => clickHandler(gambit, label);
  const tooltipId = `${gambit.id}-${gambit.action.key}-tooltip`;
  return (
    <div className="gambit">
      <Bit bit={gambit.target} onClick={onClickMaker("target")} />
      <Bit bit={gambit.condition} onClick={onClickMaker("condition")} />
      <>
        <Bit
          bit={gambit.action}
          onClick={onClickMaker("action")}
          tooltipId={tooltipId}
        />
        {gambit.action.type === "magic" && (
          <GambitTooltip action={gambit.action} id={tooltipId} />
        )}
      </>
    </div>
  );
}
